export default __webpack_public_path__ + "static/media/check.9b86756e.svg";